import {
  GET_BENEFIT_GROUP_ITEMS,
  GET_BENEFIT_GROUP_ITEMS_SUCCESS,
  GET_BENEFIT_GROUP_ITEMS_ERROR,
  GET_BENEFIT_GROUP_ITEMS_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetBenefitGroupItemsList = (state = initialState, action) => {
  switch (action.type) {
    case GET_BENEFIT_GROUP_ITEMS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_BENEFIT_GROUP_ITEMS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_BENEFIT_GROUP_ITEMS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case GET_BENEFIT_GROUP_ITEMS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetBenefitGroupItemsList;
